import { render, staticRenderFns } from "./BizTaskNotifyMeList.vue?vue&type=template&id=66ebe559&scoped=true&"
import script from "./BizTaskNotifyMeList.vue?vue&type=script&lang=js&"
export * from "./BizTaskNotifyMeList.vue?vue&type=script&lang=js&"
import style0 from "./BizTaskNotifyMeList.vue?vue&type=style&index=0&id=66ebe559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebe559",
  null
  
)

export default component.exports